import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Deduplicator from './Deduplicator';
import FieldMapper from './FieldMapper';
import Header from "./Header";
import './App.css';

const API_BASE = 'https://listmanipulator.yellowletterhq.com/api';

function Home() {
  return (
    <div id="main-wrapper" style={{ textAlign: 'center', padding: '50px 20px' }}>
      <h1>YLHQ - List Manipulator</h1>
      <Link
        to="/deduplicator"
        className="main-btn"
        style={{ fontSize: '1.2em', padding: '12px 30px', marginTop: 30, display: 'inline-block' }}
      >
        Go to Deduplicator
      </Link>
      <Link
        to="/field-mapper"
        className="main-btn"
        style={{ fontSize: '1.2em', padding: '12px 30px', marginTop: 30, display: 'inline-block' }}
      >
        Go to Field Mapper
      </Link>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/deduplicator" element={<Deduplicator apiBase={API_BASE} />} />
        <Route path="/field-mapper" element={<FieldMapper apiBase={API_BASE} />} />
      </Routes>
    </Router>
  );
}

export default App;
